import { useState, useRef, useEffect, useMemo } from "react";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import moment from "moment";
import { EventoService } from "../../../services/EventoService";
import Modal from '../../Utility/Modal/Modal';

export default function StepAudit(props) {
    const eventoService = new EventoService();
    const dtRef = useRef();
    const nazioni = props.nazioni;
    const comuni = props.comuni;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [title, setTitle] = useState("Dettaglio evento");
    const [content, setContent] = useState();
    const mapColumn = {
        'id': 'Id oggetto',
        'comune': 'Comune',
        'plesso': 'Scuola',
        'annoCorso': 'Anno di corso',
        'ordineGrado': 'Ordine e grado',
        'indirizzoDiStudio': 'Indirizzo di studio',
        'isAssegnato': 'Conferma di assegnazione',
        'confermaComunicazioneAssegnazione': 'Conferma comunicazione di assegnazione',
        'nome': 'Nome',
        'cognome': 'Cognome',
        'pec': 'PEC',
        'email': 'Email',
        'prefisso': 'Prefisso',
        'capDomicilio': 'CAP (Domicilio)',
        'capResidenza': 'CAP (Residenza)',
        'cittadinanza': 'Cittadinanza',
        'codiceFiscale': 'Codice fiscale',
        'viaDomicilio': 'Via (Domicilio)',
        'viaResidenza': 'Via (Residenza)',
        'civicoDomicilio': 'Civico (Domicilio)',
        'civicoResidenza': 'Civico (Residenza)',
        'domicilioComeResidenza': 'Domicilio come residenza',
        'tipoRichiedente': 'Tipo richiedente',
        'eta': 'Età',
        'sesso': 'Sesso',
        'dataNascita': 'Data di nascita',
        'accessoConVoucher': 'Accesso con voucher',
        'titoloDiStudioPosseduto': 'Titolo di studio posseduto',
        'residenzaComeRichiedente': 'Residenza coincide col richiedente',
        'categoriaAppartenenzaStudente': 'Categoria di appartenenza dello studente',
        'dsu': 'DSU',
        'iban': 'IBAN',
        'denominazioneBanca': 'Nome banca',
        'telefono': 'Telefono',
        // 'condizioneOccupazionale': 'Condizione di occupazione',
        'iscrizione': 'Iscrizione',
        'codice': 'Codice',
        'dataAnnullamento': 'Data di annullamento',
        'dataPresentazione': 'Data di presentazione',
        'dataAggiornamento': 'Data di rettifica',
        'statoRichiesta': 'Stato della domanda',
        'createdAt': 'Data creazione oggetto',
        'comuneResidenza': 'Comune (Residenza)',
        'comuneDomicilio': 'Comune (Domicilio)',
        'statoResidenza': 'Stato (Residenza)',
        'statoDomicilio': 'Stato (Domicilio)',
        'dataRinuncia': 'Data di rinuncia',
        'dataAggiornamentoSecondoAccesso': 'Data di aggiornamento (secondo accesso)',
        'dataAggiornamentoTerzoAccesso': 'Data di aggiornamento (terzo accesso)',
        'dataRettificaIban': 'Data di rettifica IBAN',
        'value': 'Id'
    }

    const mapValue = {
        MEDIA: "Scuola secondaria di primo grado (Scuola media)",
        SUPERIORE: "Scuola secondaria di secondo grado (Scuola superiore)",
        NESSUN_TITOLO: "Nessun Titolo",
        LICENZA_ELEMENTARE: "Licenza elementare",
        LICENZA_MEDIA: "Licenza media",
        PERSONE_CON_DISABILITA: "Persone con disabilità",
        SENZA_TETTO: "Persone senza tetto o persone colpite da esclusione abitativa",
        APPARTENENTE_MINORANZE: "Appartenente a minoranze a rischio esclusione",
        PARTECIPANTI_ORIGINE_STRANIERA: "Partecipanti di origine straniera",
        CITTADINO_PAESI_TERZI: "Cittadino/a di paesi terzi",
        ZONE_RURALI: "Partecipanti provenienti da zone rurali",
        NESSUNA_DELLE_PRECENDENTI: "Nessuna delle precedenti",
        STUDENTE_MAGGIORENNE: "Sono uno/a studente/studentessa maggiorenne e sto presentando domanda per me",
        GENITORE: "Sto presentando domanda per mio/a figlio/a",
        TUTORE_LEGALE: "Sto presentando domanda per uno/a studente/studentessa di cui sono tutore o legale rappresentante",
        1: "1° anno",
        2: "2° anno",
        3: "3° anno",
        4: "4° anno",
        5: "5° anno",
        6: "6° anno",
    };

    const openModal = (row) => {
        console.log(row);
        setTitle(`Dettaglio evento di ${row.entity}`);
        const columns = Object.keys(row.oggetto)
            .filter(el => ![
                    "codiceDomanda",
                    "createdBy",
                    "lastModifiedBy",
                    "lastModifiedDate",
                    "completato",
                    "richiestaDatiBeneficiario",
                    "richiestaIscrizioneScolastica",
                    "richiestaDatiPagamento",
                    "richiestaRapportoBeneficiario",
                    "richiestaDatiRichiedente",
                    "comuneNascita",
                    "isee",
                    "canBeSaved",
                    "canBeUpdated",
                    "condizioneOccupazionale",
                    "canBeSecondoAccesso"
                ].includes(el) && 
                mapColumn.hasOwnProperty(el));
        const content = (
            <ul>
              {columns.map((el, index) => (
                <>
                    {["comune", "comuneResidenza", "comuneDomicilio"].includes(el) && row.entity !== "RichiestaIscrizioneScolastica"? 
                        <li
                            key={'provincia_'+index}
                            className="rtds-mb-2 rtds-border-b rtds-pb-0 rtds-border-gray-02"    
                        >
                            <strong>
                                Provincia{" "}
                                {el.includes("Residenza") ? "(Residenza)" : el.includes("Domicilio") ? "(Domicilio)" : ""}
                            </strong>: {writeValue(row.oggetto[el], "provincia", row)}
                        </li> : null
                    }
                    <li
                        key={el + "_" + index}
                        className="rtds-mb-2 rtds-border-b rtds-pb-0 rtds-border-gray-02"
                    >
                        <strong>{mapColumn[el]}</strong>: {writeValue(row.oggetto[el], el, row)}
                    </li>
                </>
              ))}
            </ul>
        );
        setIsModalOpen(true);
        setContent(content);
    }

    const writeValue = (data, el, row) => {
        switch(el) {
            case "confermaComunicazioneAssegnazione":
                return data? "CONFERMATO": "NON_CONFERMATO";
            case "accessoConVoucher":
                return data === 'N'? 'NO' : 'SI';
            case "domicilioComeResidenza":
            case "residenzaComeRichiedente":
            case "isAssegnato":
                return data? "SI": "NO";
            case "sesso":
                return data === "M"? "Maschio": "Femmina";
            case "iscrizione":
                return data === "I"? "Media" : "Superiore";
            case "comune":
                return data?.denominazione;
            case "annoCorso":
            case "condizioneOccupazionale":
            case "ordineGrado":
            case "titoloDiStudioPosseduto":
            case "categoriaAppartenenzaStudente":
                return mapValue[data];
            case "dataNascita":
                return moment(data).format("DD/MM/YYYY");
            case "createdAt":
                return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
            case "statoResidenza":
            case "statoDomicilio":
                return nazioni.find(nazione => nazione.id === data?.id)?.nome;
            case "comuneDomicilio":
            case "comuneResidenza":
                return comuni?.[data]?.denominazione;
            case "provincia":
                return comuni?.[data]?.denominazione_provincia;
            case "dataPresentazione":
            case "dataAnnullamento":
            case "dataAggiornamentoSecondoAccesso":
            case "dataAggiornamento":
            case "dataRettificaIban":
            case "dataAggiornamentoTerzoAccesso":
                if(!data) return "";
                return moment(data).format("DD/MM/YYYY HH:mm:ss");
            default:
                return data;
        }
    }

    const dtOptions = useMemo(() => {
        return {
        columns: [
            {
                name: "Id",
                data: "id",
                visible: true,
                sortable: false,
                searchable: false,
            },
            {
                name: "Azione",
                data: "azione",
                visible: true,
                sortable: true,
                searchable: true,
            },
            {
                name: "C.F. Autore",
                data: "codiceFiscale",
                visible: true,
                sortable: true,
                searchable: true,
            },
            {
                name: "Oggetto",
                data: "entity",
                visible: true,
                sortable: true,
                searchable: true,
            },
            {
                name: "Codice domanda",
                data: "oggetto",
                visible: true,
                sortable: false,
                searchable: true,
                cell: (row, cell) => {
                    return row.oggetto.codice?? row.oggetto.codiceDomanda;
                }
            },
            {
                name: "Data evento",
                data: "createdAt",
                visible: true,
                sortable: true,
                searchable: false,
                cell: (row, col) => {
                    return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
                }
            },
            {
                name: "Azioni",
                data: "",
                visible: true,
                sortable: false,
                searchable: false,
                cell: (row, col) => (
                    <div>
                      <button
                        type="button"
                        className="rtds-btn rtds-btn--secondary"
                        onClick={() => {openModal(row)}}
                        title="Visualizza"
                      >
                        Dettaglio
                        <svg
                            className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                            aria-hidden="true"
                            focusable="false"
                            role="img"
                        >
                            <use
                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--eye`}
                            />
                        </svg>
                      </button>
                    </div>
                  ),
            }
        ],
        serverSide: true,
        rows: [],
        sorts: [],
        hideSearch: false,
        title: "Elenco eventi Domande",
        ajax: eventoService.getAllDt,
        ajaxParams: {
            entity: [
                "Richiesta",
                "RichiestaDatiRichiedente",
                "RichiestaRapportoBeneficiario",
                "RichiestaIscrizioneScolastica",
                "RichiestaDatiPagamento",
                "RichiestaDatiBeneficiario",
                "RichiestaIstruttoriaArs"
            ],
            searchableItems: ["codice", "codiceDomanda"]
        },
        };
    }, []);

    return (
        <>
            <DataTableWrapper
                ref={dtRef}
                dtOptions={dtOptions}
            />

            <Modal
                isOpen={isModalOpen}
                title={title}
                onClose={() => setIsModalOpen(false)}
                hideActionButton={true}
                closeLabel='Chiudi'
                content={content}
            />
        </>
    );
}
